import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { SDRecentItem, SDWindowEntry } from '@compiere-ws/models/apiz-domains';
import { StudioApiService } from '@studio/services/studio-api.service';
import { StudioMessageService } from '@studio/services/studio-message.service';
import { TranslateService } from '@ngx-translate/core';
import { handleStudioError } from '@studio/utils/error-handler.util';
import { catchError, map, of } from 'rxjs';

export const SDRecentItemsResolver: ResolveFn<SDRecentItemsDataResolved> = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
) => {
  const studioApiService = inject(StudioApiService);
  const messageService = inject(StudioMessageService);
  const translateService = inject(TranslateService);
  
  return studioApiService.getRecentItems().pipe(
    map((items) => ({ items })),
    catchError((error) => {
      const errorMessage = handleStudioError(
        error,
        translateService,
        messageService,
        'studio.errors.operations.loadFailed'
      );
      return of({ error: errorMessage, items: [] });
    })
  );
};

export const SDMenuItemsResolver: ResolveFn<SDWindowEntriesDataResolved> = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
) => {
  const studioApiService = inject(StudioApiService);
  const messageService = inject(StudioMessageService);
  const translateService = inject(TranslateService);
  
  return studioApiService.getWindowEntries().pipe(
    map((items) => ({ items })),
    catchError((error) => {
      const errorMessage = handleStudioError(
        error,
        translateService,
        messageService,
        'studio.errors.operations.loadFailed'
      );
      return of({ error: errorMessage, items: [] });
    })
  );
};

type SDItemsDataResolved<T> = { items: T[]; error?: string };

export type SDRecentItemsDataResolved = SDItemsDataResolved<SDRecentItem>;
export type SDWindowEntriesDataResolved = SDItemsDataResolved<SDWindowEntry>;
